import React from 'react';
import style from './DetailsStatusBadge.scss';

export const DetailsStatusBadge = ({
                                       status,
                                       translatedState
                                   }) => {
    const classesMy = [style[status], style.dot].join(' ');

    return (
        <div className={style.discovery}>
            <div
                className={`${style.text} ${style.withoutBackButton}`}>
                <div className={classesMy}/>
                <p className={style.categoryLabel}>{translatedState}</p>
            </div>
        </div>
    );
};
